class Table {
  constructor({
    id = null,
    title = '',
    description = '',
    apiName = '',
    layout = null,
    queryParams = {},
    createdAt = null,
    updatedAt = null,
    uid = null,
  } = {}) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.layout = layout;
    this.queryParams = queryParams;
    this.apiName = apiName;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.uid = uid;
  }

  setData(data) {
    this.id = data.id;
    this.title = data.title;
    this.description = data.description;
    this.layout = data.layout;
    this.queryParams = data.queryParams || {};
    this.apiName = data.apiName;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.uid = data.uid;
  }

  toUpdate() {
    return {
      title: this.title,
      description: this.description,
      layout: this.layout,
      apiName: this.apiName,
      queryParams: this.queryParams,
    };
  }
}

export default Table;
